"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDocumentTitle = exports.transformRoutes = void 0;
var react_router_config_1 = require("react-router-config");
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
var initTitle = '';
/**
 * route path 拼接
 * 兼容 path 为数组的情况
 * path 为数组时不拼接父级路由 path
 */
function transformRoutes(routes, parentPath) {
    if (parentPath === void 0) { parentPath = ''; }
    routes.forEach(function (route) {
        route.path = Array.isArray(route.path) ? route.path : "" + parentPath + route.path;
        if (route.routes) {
            transformRoutes(route.routes, route.path === '/' || Array.isArray(route.path) ? '' : route.path);
        }
    });
}
exports.transformRoutes = transformRoutes;
var getTargetRoutes = function (routes, pathname) {
    var _a;
    var cloneRoutes = lodash_clonedeep_1.default(routes);
    transformRoutes(cloneRoutes);
    var matchedRoutes = react_router_config_1.matchRoutes(cloneRoutes, pathname);
    var matchedLen = matchedRoutes.length;
    if (matchedLen === 0) {
        return null;
    }
    return (_a = matchedRoutes[matchedRoutes.length - 1]) === null || _a === void 0 ? void 0 : _a.route;
};
function setDocumentTitle(router, init) {
    if (init === void 0) { init = false; }
    var history = router.history;
    if (init) {
        initTitle = document.title;
    }
    // 设置页面标题
    var routes = router.routes;
    var pathname = history.location.pathname;
    var matchedRoute = getTargetRoutes(routes, pathname);
    document.title = (matchedRoute === null || matchedRoute === void 0 ? void 0 : matchedRoute.title) || initTitle;
}
exports.setDocumentTitle = setDocumentTitle;
//# sourceMappingURL=util.js.map